import { render, staticRenderFns } from "./BonusPaymentRecordsPopup.vue?vue&type=template&id=4ac59797&scoped=true"
import script from "./BonusPaymentRecordsPopup.vue?vue&type=script&lang=js"
export * from "./BonusPaymentRecordsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac59797",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ac59797')) {
      api.createRecord('4ac59797', component.options)
    } else {
      api.reload('4ac59797', component.options)
    }
    module.hot.accept("./BonusPaymentRecordsPopup.vue?vue&type=template&id=4ac59797&scoped=true", function () {
      api.rerender('4ac59797', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/userDetails/components/BonusPaymentRecordsPopup.vue"
export default component.exports